import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from '../../../core/http/api-client.service';
import { GlobalSettingsDto, UpdateGlobalSettingsRequest } from './global-settings.models';

@Injectable({
  providedIn: 'root'
})
export class GlobalSettingsService
{
  private readonly apiClient = inject(ApiClientService);

  public getSettings(): Observable<GlobalSettingsDto>
  {
    return this.apiClient.get<GlobalSettingsDto>('/global-settings');
  }

  public updateSettings(payload: UpdateGlobalSettingsRequest): Observable<GlobalSettingsDto>
  {
    return this.apiClient.patch<GlobalSettingsDto, UpdateGlobalSettingsRequest>(
      '/global-settings',
      payload,
    );
  }
}
